import { useState, useEffect, FC, createElement } from "react";
import { Auth } from "aws-amplify";
import { Navigate } from "react-router-dom";
import { encode as base64_encode } from "base-64";

interface Props {
  component: FC;
}
const ProtectedRoute: FC<Props> = ({ component }) => {
  const [isAuthenticated, setLoggedIn] = useState(true);
  useEffect(() => {
    (async () => {
      let user = null;

      try {
        user = await Auth.currentAuthenticatedUser();
        if (user) {
          setLoggedIn(true);
        } else {
          setLoggedIn(false);
        }
      } catch (e) {
        setLoggedIn(false);
        console.log(e);
      }
    })();
  });

  return <div>{!isAuthenticated ? <Navigate to={`/signin?last=${base64_encode(window.location.href)}`} /> : createElement(component)}</div>;
};

export default ProtectedRoute;
